module.exports = __webpack_public_path__ + "img/icon-home-grey.c163b20f.svg";